// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_gP4","cls2":"ButtonsPage-cls2_OZI ButtonsPage-cls1_gP4"};